import { LoadDeletedEvent } from '@rematter/frontend-lib-api-client/grpc/trade/load_events_pb';
import { LoadStatus } from '@rematter/frontend-lib-api-client/grpc/trade/load_pb';
import {
  BadgeField,
  Col,
  FieldDisplay,
  humanReadableDateTime,
  IDField,
  ThemeColor,
} from '@rematter/ui-web';

import { loadStatusLabels } from '../enumLabels';

import { protoTimestampToZonedDateTimeString } from '@/audit-log/_components/_shared';
import { getLocale } from '~/shared/utils/locale';

const getStatusColor = (status: LoadStatus): ThemeColor => {
  switch (status) {
    case LoadStatus.PENDING:
      return 'warning';
    case LoadStatus.SHIPPED:
      return 'teal';
    case LoadStatus.RECEIVED:
      return 'primary';
    case LoadStatus.RECONCILED:
      return 'success';
    case LoadStatus.UNASSIGNED:
      return 'neutral';
    case LoadStatus.VOIDED:
      return 'failure';
    default:
      return 'neutral';
  }
};

type LoadDeletedDetailProps = {
  event: LoadDeletedEvent;
};

export const LoadDeletedDetail = ({ event }: LoadDeletedDetailProps) => {
  const load = event.load;

  if (!load) {
    return (
      <Col className="@LoadDeletedDetail items-center justify-center p-4 text-neutral/40">
        <span>No data available</span>
      </Col>
    );
  }

  const shippedDateStr = protoTimestampToZonedDateTimeString(load.shippedDate);

  return (
    <Col className="@LoadDeletedDetail gap-3" gap3>
      <Col
        className="rounded-md border border-failure/20 bg-failure/5 p-3"
        gap2
      >
        <span className="text-xs font-medium text-failure/80">
          Deleted Load
        </span>
        <div className="grid grid-cols-2 gap-x-4 gap-y-1">
          <IDField label="ID" value={load.id} />
          <FieldDisplay
            label="Document Number"
            value={String(load.documentNumber)}
          />
          <BadgeField
            label="Status"
            value={loadStatusLabels[load.status]}
            color={getStatusColor(load.status)}
          />
          <IDField label="Booking ID" value={load.bookingId} />
          <IDField label="Sales Order ID" value={load.salesOrderId} />
          <IDField label="Facility ID" value={load.facilityId} />
          {shippedDateStr && (
            <FieldDisplay
              label="Shipped Date"
              value={humanReadableDateTime(shippedDateStr, {
                locale: getLocale(),
              })}
            />
          )}
        </div>
      </Col>
    </Col>
  );
};
